import type React from 'react';
import { useEffect, useState } from 'react';
import type { MagneticWallItemSize } from './MagneticWallItem';

const EXPANDED_MIN_WIDTH = 246;

const useIsExpanded = (element: HTMLElement | null | undefined) => {
  const [isExpanded, setIsExpanded] = useState(
    () => (element?.offsetWidth ?? 0) >= EXPANDED_MIN_WIDTH,
  );

  useEffect(() => {
    if (!element) return undefined;
    setIsExpanded((element?.offsetWidth ?? 0) >= EXPANDED_MIN_WIDTH);

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]?.contentRect;
      if (entry) {
        setIsExpanded(entry.width >= EXPANDED_MIN_WIDTH);
      }
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [element]);

  return isExpanded;
};

function useMagneticWallItemSize(
  containerRef: React.RefObject<HTMLElement>,
): MagneticWallItemSize {
  const isExpanded = useIsExpanded(containerRef.current);

  return isExpanded ? 'full' : 'compact';
}

export default useMagneticWallItemSize;
